import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { productKeys } from './keys';

import type { TypeGetActiveSkusSkuCodeResponse, TypeSkuDetailDataWithIsTemp } from '~/types/product.types';

/**
 * [상품관리] 운영상품 상세 조회 API
 * @param skuCode 상품 코드
 */
export const fetchActiveSkusSkuCode = async (skuCode: string): Promise<TypeSkuDetailDataWithIsTemp> => {
  const { data } = await axiosInstance.get<TypeGetActiveSkusSkuCodeResponse>(
    `${API_ENDPOINT.PRODUCT.GET_ACTIVE_SKUS_SKU_CODE}/${skuCode}`
  );
  return data.data;
};

type UseGetActiveSkusSkuCodeQueryOptions = {
  skuCode: string;
  enabled?: boolean;
};

/**
 * [상품관리] 운영상품 상세 조회 Query Hook
 */
export const useGetActiveSkusSkuCodeQuery = ({ skuCode, enabled = true }: UseGetActiveSkusSkuCodeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.activeSkuDetail(skuCode),
    queryFn: () => fetchActiveSkusSkuCode(skuCode),
    enabled: enabled && !!skuCode,
    staleTime: 0,
    gcTime: 0,
  });
};
